<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click="abrirModal()">
            <span> <i class="fa fa-plus mr-2"></i> Inserir Documento </span>
        </b-button>
        <b-modal
            id="modalInserirDocumento"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop>
            <div slot="modal-title">
                Documento
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Nome do arquivo</label>
                        <b-form-textarea
                            :rows="4"
                            v-model="descricaoArquivo"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>
                            O nome do arquivo é obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione um documento em PDF ou Excel..."
                            accept=".pdf,.xlsx,.xls"
                            ref="arquivoInput"
                            @change="validarTipoArquivo"
                        ></b-form-file>
                        <b-form-invalid-feedback :state="arquivoValido">
                            Apenas arquivos PDF ou Excel são permitidos
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    class="ml-1"
                    @click.stop="salvarDocumento()"
                    :disabled="this.$v.$invalid">
                    Salvar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

// Validador customizado para extensões de arquivo
const arquivoValido = (value) => {
    if (!value) return false
    const nomeArquivo = value.name ? value.name.toLowerCase() : ''
    return nomeArquivo.endsWith('.pdf') || nomeArquivo.endsWith('.xls') || nomeArquivo.endsWith('.xlsx')
}

export default {
    props: {
        pleito: {
            type: Object,
            default: () => ({})
        },
        servicos: {
            type: Object
        },
        conformidadeTecnica: {
            type: Object
        },
    },

    validations: {
        descricaoArquivo: { required },
        arquivo: { required, arquivoValido }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            vcNomeArquivo: null,
            arquivo: null,
            descricaoArquivo: null,
            arquivoValido: true
            }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.$v.$reset()
            this.arquivo = null
            this.descricaoArquivo = null
            this.arquivoValido = true
            this.erros = []
        },

        validarTipoArquivo(arquivo) {
            if (!arquivo) {
                this.arquivoValido = true
                return
            }
            
            const nomeArquivo = arquivo.name.toLowerCase()
            this.arquivoValido = nomeArquivo.endsWith('.pdf') || nomeArquivo.endsWith('.xls') || nomeArquivo.endsWith('.xlsx')
            
            if (!this.arquivoValido) {
                this.$nextTick(() => {
                    this.$refs.arquivoInput.reset()
                    this.arquivo = null
                })
                this.$toast.error('Apenas arquivos PDF ou Excel (.pdf, .xls, .xlsx) são permitidos')
            }
        },
        
        salvarDocumento() {
            // Validação adicional antes de salvar
            if (!this.arquivoValido) {
                this.$toast.error('Selecione um arquivo válido (PDF ou Excel)')
                return
            }

            this.$store.dispatch('addRequest')
            let documentoDto = {
                pleitoId: this.pleito.pleitoId,
                vcNomeArquivo: this.arquivo.name,
                arquivo: this.arquivo,
                conformidadeTecnicaId: this.conformidadeTecnica.conformidadeTecnicaId,
                descricaoArquivo:this.descricaoArquivo
            }
            this.servicos.inserirDocumentoConformidadeTecnica(documentoDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.documentos = response.data
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        }
    }
}
</script>
